<template>
    <div class="layout">
        <div class="layout__header">
            <h3>Comprobantes</h3>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <label v-show="tipoComprobante === '01' || tipoComprobante === '99'" for="impagos">
                        <input @change="$refs.tablaComprobantes.loadRows()" type="checkbox" id="impagos" v-model="form.impagos"> <span>Ver comprobantes impagos</span>
                    </label>
                </div>
            </div>
            <div class="col-xs-12 col-md-8">
                <div class="form-field">
                    <div class="form-group">
                        <input-field v-model="nombrePersona" readonly id="filtroPersona" placeholder="Seleccione una persona...">
                            Persona
                        </input-field>
                        <button @click="$modal.show('consultaPersonas')" v-show="form.id_persona === ''" class="btn-info" type="button"><i class="fa fa-search"></i></button>
                        <button @click="quitarPersona" v-show="form.id_persona !== ''" class="btn-danger" type="button"><i class="fa fa-ban"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <k-table ref="tablaComprobantes" 
            @ver="ver"
            :tipoComprobante="tipoComprobante"
            :createButton="false" 
            :esComprobante="true" 
            :filterStatus="false" 
            :editButton="false" 
            :deleteButton="false" 
            @seleccionar="seleccionar" 
            :path="path" 
            :params="form"
            :buttons="[
                {
                    text : '',
                    class : 'btn-info',
                    icon : 'fa-eye',
                    event : 'ver'
                }
            ]"
            :columns="[
            {
                display : 'Fecha de emisión',
                value : 'fecha_emision'
            },
            {
                display : 'N° establecimiento',
                value : 'codigo_establecimiento'
            },
            {
                display : 'N° emisor',
                value : 'codigo_emisor'
            },
            {
                display : 'N° Secuencial',
                value : 'numero_secuencial',
            },
            {
                display : 'Cliente',
                value : 'nombre_cliente',
            },
            {
                display : 'N° Identificación del cliente',
                value : 'numero_identificacion'
            },
            {
                display : 'Estado de pago',
                value : 'descripcion_comprobante_pagado',
                hidden : tipoComprobante !== '01'
            },
            {
                display : 'Total sin impuestos',
                value : 'total_sin_impuestos',
                numeric : true,
                hidden : tipoComprobante === '07'
            },
            {
                display : 'IVA',
                value : 'valor_iva',
                numeric : true,
                hidden : tipoComprobante === '07'
            },
            {
                display : 'ICE',
                value : 'valor_ice',
                numeric : true,
                hidden : tipoComprobante === '07'
            },
            {
                display : 'IRBPNR',
                value : 'valor_irbpnr',
                numeric : true,
                hidden : tipoComprobante === '07'
            },
            {
                display : 'Total',
                value : 'valor_total',
                numeric : true
            },
            {
                display : 'Estado',
                value : 'estado'
            }
        ]"></k-table>
        <modal width="55%" height="auto" name="consultaPersonas" scrollable>
            <lista-personas :createButton="false" :tipoFiltro="tipoComprobante === '07'?'P':'C'" :filterStatus="false" @selected="selectedPersona"></lista-personas>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        tipoComprobante : {
            type : String,
            default : '01',
            required : false
        }
    },
    data : function () {
        return {
                comprobantes : [],
                form : {
                    tipo_comprobante : this.tipoComprobante,
                    id_persona : '',
                    impagos : false
                },
                path : url + '/comprobantes/search',
                url : url,
                nombrePersona: ''
        }
        
    },
    methods : {  
        ver : function (comprobante) {
            window.open(this.url + '/comprobantes?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + comprobante.id_comprobante, '_blank');
        },  
        seleccionar : function(currentComprobante) {     
            this.$emit('selected', currentComprobante);
        },
        selectedPersona : function (persona) {
            this.nombrePersona = persona.nombre;
            this.form.id_persona = persona.id;
            this.$modal.hide('consultaPersonas');
            this.$refs.tablaComprobantes.loadRows();
        },
        quitarPersona : function () {
            this.nombrePersona = '';
            this.form.id_persona = '';
            this.$refs.tablaComprobantes.loadRows();
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ListaComprobantes.vue